<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

                <!-- HEADER -->
        <div class="header accent"
        fxLayout="column" fxLayoutAlign="center center"
        fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        business
                    </mat-icon>
                    <span class="logo-text h1">
                        Custódia Consolidada
                    </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Consultar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Consultar Custódia"
                            (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>

                    <!-- Botão Exportar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Exportar Custódia"
                            (click)="getAllExport()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        <!-- SEARCH -->
        <div class="search-wrapper mx-32 mx-md-0">
        <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">                    
            <input 
                #filter 
                placeholder="Buscar Por Nome, CPF ou Conta"
                [formControl]="search"
                (keyup)="onEnter(filter.value)"
                (keyup.enter)="onEnter(filter.value)"
            >
            <mat-icon 
                style="cursor: pointer;" 
                (click)="getAll()"
            >
                search
            </mat-icon>
        </div>
        </div>                    
        <!-- / SEARCH -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-tab-group dynamicHeight (selectedTabChange)="onLinkClick($event)">
                <mat-tab label="Lista">

                    <mat-card>
                        <mat-card-header style="margin-bottom: 20px">
                            <mat-card-title>Custódia Consolidada Atual</mat-card-title>
                            <mat-card-subtitle>Data da Última Atualização:  {{data_atualizacao | date:'dd/MM/yyyy'}} </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <ngx-datatable 
                                #table 
                                class='material striped' 
                                [loadingIndicator]="loadingIndicator"
                                [columns]="columns" 
                                [columnMode]="'force'" 
                                [headerHeight]="50"                       
                                [footerHeight]="50" 
                                [rowHeight]="'auto'" 
                                [rows]='rows'
                                [limit]="params.per_page"                        
                                (sort)="onSort($event)">                     
                
                                <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="true">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                        <span 
                                            matTooltip="Clique aqui para alterar o valor da cotação atual" 
                                            style="cursor: pointer" 
                                            (click)="alterarCotacao(row.ativo.id)"
                                            *ngIf="this.user.role_id == 4 || this.user.role_id == 7 || this.user.role_id == 2">
                                            <span 
                                                style="padding: 5px; border-radius: 10px;" 
                                                [className]="row.cor_hexadecimal"
                                            >
                                                <b>{{row.ativo.sigla}}</b>
                                            </span>
                                        </span>
                                        <span *ngIf="this.user.role_id != 4 && this.user.role_id != 7 && this.user.role_id != 2">
                                            <b>{{row.ativo.sigla}}</b> 
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>
                
                                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true" >
                                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                                        <span style="cursor: pointer;" (click)="redirecionaCliente(cliente.id)">
                                            <b>{{cliente.numero_xp}} - {{cliente.nome}}</b>
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>                       
                
                                <ngx-datatable-column name="Qtd. Exec" prop="qtd" [sortable]="true">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                                        
                                        <span [ngClass]="{'negativo':row.ativo_bloqueado == true}" matTooltip="Quantidade Bloqueada" *ngIf="row.ativo_bloqueado == true">
                                            {{row.qtd | number : '1.0-0'}}
                                        </span>
                                        <span *ngIf="row.ativo_bloqueado == false">
                                            {{row.qtd | number : '1.0-0'}} 
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>
                
                                <ngx-datatable-column name="Preço (R$)" prop="preco_executado" [sortable]="true">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                        {{row.preco_executado | number : '1.2-2'}}
                                    </ng-template>
                                </ngx-datatable-column>
        
                                <ngx-datatable-column name="Volume Inicial (R$)" prop="vlr_financeiro" [sortable]="true">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                        {{ getValorFinanceiro(row)  | number : '1.2-2'}} 
                                    </ng-template>
                                </ngx-datatable-column>
        
                                <ngx-datatable-column name="Vol. Fin. Hoje(R$)" prop="cotacao_atual_fin" [sortable]="true">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                        <span matTooltip="Cotação atual: R$ {{row.ativo.cotacao_atual | number : '1.2-2'}}  (atualizado: {{row.ativo.updated_at | date:'dd/MM/yyyy H:mm'}}) ">
                                            {{getCotacaoAtual(row) | number : '1.2-2'}}
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>
        
                                <ngx-datatable-column name="%" prop="percentual" [sortable]="true">
                                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                        <span *ngIf="row.preco_executado > 0 && row.ativo.tipo != 'OPCAO' " [ngClass]="{'negativo':row.percentual  < 0 , 'positivo': row.percentual  > 0  }">
                                            
                                            {{ row.percentual | number : '1.2-2' }} %
        
                                            <i class="material-icons negativo" *ngIf="row.percentual < 0" style="float: left">
                                            trending_down
                                            </i>                                          
                                            <i class="material-icons positivo" *ngIf="row.percentual > 0" style="float: left">
                                            trending_up
                                            </i>
                                            <i class="material-icons" *ngIf="row.percentual === 0" style="float: left">
                                            trending_flat
                                            </i>
                                            
                                        </span>
                                    </ng-template>
                                </ngx-datatable-column>        
                               
                            </ngx-datatable>
                
                            <div style="padding: 5px 10px">
                                <mat-paginator 
                                    #paginator 
                                    [length]="length"
                                    [pageSize]="pageSize"
                                    [pageSizeOptions]="pageSizeOptions"
                                    (page)="pageEvent($event)">
                                </mat-paginator>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>

                <mat-tab label="Concentração Por Ativo"> 
                    <mat-card>
                        <ngx-datatable 
                            #tableAtivo
                            class='material' 
                            [summaryRow]="enableSummary"
                            [summaryPosition]="summaryPosition" 
                            [summaryHeight]="50"
                            [loadingIndicator]="loadingListaAtivo"
                            [columns]="columns" 
                            [columnMode]="'force'" 
                            [headerHeight]="50"                       
                            [footerHeight]="50" 
                            [rowHeight]="'auto'" 
                            [rows]='rowsAtivo'
                            [limit]="paramsAtivo.per_page"
                            (sort)="onSortAtivo($event)">
            
                            <ngx-datatable-column name="ATIVO" prop="ativo" [sortable]="true" [summaryFunc]="totalCustodia" >
                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                    <span>
                                        <b>{{row.ativo}}</b>
                                    </span>                                    
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Quantidade" prop="quantidade" [sortable]="true"  >
                                <ng-template let-rowIndex="rowIndex" let-quantidade="value" ngx-datatable-cell-template>
                                    {{quantidade | number : '1.0'}}
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Financeiro (R$)" prop="vlr_financeiro" [sortable]="true" [summaryFunc]="somaFinanceiro">
                                <ng-template 
                                    let-rowIndex="rowIndex" 
                                    let-vlr_financeiro="value" 
                                    ngx-datatable-cell-template>
                                    {{vlr_financeiro | number : '1.2-2'}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column 
                                name="Financeiro Hoje (R$)" 
                                prop="vlr_financeiro_hoje" 
                                [sortable]="true" 
                                [summaryFunc]="somaFinanceiroHoje"
                            >
                                <ng-template
                                    let-rowIndex="rowIndex" 
                                    let-row="row" 
                                    ngx-datatable-cell-template>
                                    {{row.vlr_financeiro_hoje  | number : '1.2-2'}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="% Participação" prop="percentual" [sortable]="false" >
                                <ng-template 
                                    let-rowIndex="rowIndex" 
                                    let-row="row" 
                                    ngx-datatable-cell-template>
                                    {{  percentualFinanceiro(row.vlr_financeiro) | number : '1.2-2'}} %
                                </ng-template>
                            </ngx-datatable-column>


                            <ngx-datatable-column name="Qtd. Clientes" prop="qtd_clientes" [sortable]="false" >
                                <ng-template 
                                    let-rowIndex="rowIndex" 
                                    let-row="row" 
                                    ngx-datatable-cell-template>
                                    {{  row.qtd_clientes | number : '1.0-0'}}
                                </ng-template>
                            </ngx-datatable-column>


                            <ngx-datatable-column name="%" prop="percentual" [sortable]="true" >
                                <ng-template
                                    let-rowIndex="rowIndex" 
                                    let-row="row" 
                                    ngx-datatable-cell-template>
                                    <span [ngClass]="{
                                        'negativo': (row.quantidade * row.cotacao_atual) < row.vlr_financeiro, 
                                        'positivo': (row.quantidade * row.cotacao_atual) > row.vlr_financeiro}">
                                        
                                        {{ percentualFinanceiroDiferenca(row) | number : '1.2-2'}} %

                                        <i class="material-icons negativo"  *ngIf="(row.quantidade * row.cotacao_atual) < row.vlr_financeiro" style="float: left">
                                            trending_down
                                        </i>
                                        <i class="material-icons positivo"  *ngIf="(row.quantidade * row.cotacao_atual) > row.vlr_financeiro" style="float: left">
                                            trending_up
                                        </i>
                                        <i class="material-icons"  *ngIf="(row.quantidade * row.cotacao_atual) == row.vlr_financeiro" style="float: left">
                                            trending_flat 
                                        </i>

                                    </span>
                                   
                                </ng-template>
                            </ngx-datatable-column>
            
                        </ngx-datatable>
            
                        <div style="padding: 5px 10px">
                            <mat-paginator 
                                #paginator 
                                [length]="lengthAtivo"
                                [pageSize]="pageSizeAtivo"
                                [pageSizeOptions]="pageSizeOptionsAtivo"
                                (page)="pageEventAtivo($event)">
                            </mat-paginator>
                        </div>
                    </mat-card>
                </mat-tab>

                <mat-tab label="Concentração Por Setor">
                    <lista-custodia-rv-setor [parametro]="params"></lista-custodia-rv-setor>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>